import React from "react";
import bgslider from "../Assets/img/bgslider1.png";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import { Link } from "react-router-dom";
const SchemesSlider = () => {
  const distID = localStorage.getItem("distributorId");
  const { data, error, isLoaded } = GetRequest(
    `/Scheme/GetRunningSchemesSummary/${distID}`,
  );
  if (error !== null) {
    return <Error data="Schemes " />;
  }
  if (!isLoaded) {
    return <Loading />;
  }
  if (!data?.result || data.result.length === 0) {
    return null;
  }
  //  Split data into 2 categories
  const imageSchemes = data.result.filter(
    (item) => item.schemeCoverImage1 && item.schemeCoverImage1.trim() !== "",
  );
  const textSchemes = data.result.filter(
    (item) => !item.schemeCoverImage1 || item.schemeCoverImage1.trim() === "",
  );
  // Decide mode
  const showImageSlider = imageSchemes.length > 0;
  const showTextSlider = !showImageSlider && textSchemes.length > 0;
  // Nothing to show
  if (!showImageSlider && !showTextSlider) {
    return null;
  }
  const sliderData = showImageSlider ? imageSchemes : textSchemes;
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card shadow-sm">
          <div className="card-body p-0">
            <div
              id="schemeSliderDiv"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {sliderData.map((item, index) => (
                  <div
                    key={item.id}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <Link
                      to={`/SchemesDetails/${item.id}`}
                      style={{ textDecoration: "none" }}
                    >
                      {/* IMAGE MODE */}
                      {showImageSlider ? (
                        <>
                          <img
                            src={item.schemeCoverImage1 || bgslider}
                            alt="scheme"
                            className="d-block w-100"
                            style={{
                              height: "40vh",
                              objectFit: "initial",
                            }}
                          />
                          {/* Name below image */}
                          <div className="p-1 bg-white text-center">
                            <h3
                              style={{
                                fontWeight: "700",
                                color: "#1b5e20",
                              }}
                            >
                              {item.name}
                            </h3>
                          </div>
                        </>
                      ) : (
                        /*  TEXT MODE (Green Slider) */
                        <div
                          style={{
                            height: "40vh",
                            backgroundColor: "#0f5c4d",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "20px",
                          }}
                        >
                          <h2
                            style={{
                              color: "#fff",
                              fontWeight: "700",
                              textAlign: "center",
                            }}
                          >
                            {item.name}
                          </h2>
                        </div>
                      )}
                    </Link>
                  </div>
                ))}
              </div>
              {/* Controls */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#schemeSliderDiv"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon"></span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#schemeSliderDiv"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SchemesSlider;
